import * as z from "zod/v4";

export const rentalSlugContactFormSchema = z.object({
	name: z.string().min(1),
	email: z.email().transform((val) => val.toLowerCase()),
	phone: z.string().min(1),
	message: z.string().min(1),
	unitSlug: z.string(),
	notificationEmail: z.email(),
	unitAddress: z.string(),
	turnstileToken: z.string(),
	pageUrl: z.url(),
	routeId: z.string(),
	utmSource: z.string(),
	utmMedium: z.string(),
	utmCampaign: z.string(),
	utmContent: z.string(),
	utmTerm: z.string()
});

export type RentalSlugContactFormSchema = z.infer<typeof rentalSlugContactFormSchema>;

export const rentalSlugContactFormClientSchema = rentalSlugContactFormSchema.pick({
	name: true,
	email: true,
	phone: true,
	message: true,
	turnstileToken: true
});
